import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import { Loading } from 'element-ui';

Vue.use(Router)

var loading = null

const router = new Router({
    routes
})

/**
 * 路由拦截
 * 权限验证
 */
router.beforeEach((to, from, next) => {
    // store.commit('changeLoadingState', true)
    // if (whitelist.indexOf(to.name) === -1 && !getToken()) {
    //   store.commit('changeLoadingState', false)
    //   next('/login')
    // } else {
    //   let role = to.meta.role;
    //   role?(checkRole(role)?next():Message.error('缺少必要的权限！')):next();
    // }
    loading = Loading.service({ fullscreen: true, text: '正在加载中，请稍后...', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' });
    next()
})

router.afterEach((to) => {
    loading.close();
    if (to.meta.title) {
        document.title = to.meta.title
    }
})

export default router